import { render, staticRenderFns } from "./nav_item_link.vue?vue&type=template&id=5f393a1c&"
import script from "./nav_item_link.vue?vue&type=script&lang=js&"
export * from "./nav_item_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports